define(['angular', '../module'], function(angular, MODULE_NAME) {
    'use strict';

    var SERVICE_NAME = 'ilmnUiConfirmDialogService';
    var templateUrl = require('../views/configDialog.template.html');
    
    angular.module(MODULE_NAME)
        .service(SERVICE_NAME, ConfirmModalService);

    ConfirmModalService.$inject = ['$uibModal'];
    function ConfirmModalService($uibModal) {
        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            modalFade: true,
            size: 'sm',
            templateUrl: templateUrl
        };

        var viewOptions = {
            closeButtonText: 'Close',
            actionButtonText: 'OK',
            message: 'Perform this action?'
        };

        this.show = function (customModalDefaults, customViewOptions) {
            //Create temp objects to work with since we're in a singleton service
            var tempModalDefaults = {};
            var tempViewOptions = {};

            //Map angular-ui modal custom defaults to modal defaults defined in service
            angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);

            //Map modal.html $scope custom properties to defaults defined in service
            angular.extend(tempViewOptions, viewOptions, customViewOptions);

            if (!tempModalDefaults.controller) {
                tempModalDefaults.controller = ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                    $scope.modalOptions = tempViewOptions;
                    $scope.modalOptions.ok = function (result) {
                        $uibModalInstance.close(result);
                    };
                    $scope.modalOptions.close = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                }];
            }

            return $uibModal.open(tempModalDefaults).result;
        };
    }

    return SERVICE_NAME;
});



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-utils/scripts/confirmDialog.service.js
// module id = 19
// module chunks = 0